import { render, staticRenderFns } from "./NewsListCard.vue?vue&type=template&id=4fc03d75&"
import script from "./NewsListCard.vue?vue&type=script&lang=js&"
export * from "./NewsListCard.vue?vue&type=script&lang=js&"
import style0 from "./NewsListCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports